module.exports = __webpack_public_path__ + "img/download-excel.4a6e1444.svg";